var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook_svg__clip0_7824_5063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.197 12.043a7.2 7.2 0 10-8.325 7.113v-5.031H9.044v-2.082h1.828v-1.586c0-1.804 1.075-2.801 2.72-2.801.54.007 1.078.054 1.611.14v1.772h-.908a1.04 1.04 0 00-1.173 1.125v1.35h1.995l-.32 2.082h-1.68v5.03a7.2 7.2 0 006.08-7.112z",
    fill: "#0D0C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook_svg__clip0_7824_5063"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgFacebook;